import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import GeoUtils from '../geoUtils.js';

export default class NodeTaper extends Node
{
	static DIRECTION_TYPE =
	[
		{key: 'xAxis', label: 'X Axis'},
		{key: 'yAxis', label: 'Y Axis'},
		{key: 'zAxis', label: 'Z Axis'},
		{key: 'xzPlane', label: 'XZ Plane'},
		{key: 'xyPlane', label: 'XY Plane'},
		{key: 'yzPlane', label: 'YZ Plane'},
	]

	static OFFSET_UNITS =
	[
		{key: 'percent', label: 'Size Percentage'},
		{key: 'distance', label: 'Absolute Distance'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.DROPDOWN, 'direction', NodeTaper.DIRECTION_TYPE[4].key, { dropdownOptions: NodeTaper.DIRECTION_TYPE });

		this.addInput(PARAM_TYPE.DROPDOWN, 'use', NodeTaper.OFFSET_UNITS[0].key, { dropdownOptions: NodeTaper.OFFSET_UNITS });
		this.addInput(PARAM_TYPE.FLOAT, `start_perc`, 0.0, { minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, `end_perc`, 0.0, { minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });

		this.addInput(PARAM_TYPE.FLOAT, `start_dist`, 0.0, { minValue: -2, maxValue: 2, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, `end_dist`, 0.0, { minValue: -2, maxValue: 2, units: PARAM_UNITS.METERS });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'taper';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		const unitsToUse = this.getLastInputResult('use');
		if(strInputName === 'start_perc' || strInputName === 'end_perc')
			return unitsToUse == NodeTaper.OFFSET_UNITS[0].key;
		else if(strInputName === 'start_dist' || strInputName === 'end_dist')
			return unitsToUse == NodeTaper.OFFSET_UNITS[1].key;

		return true;
	}

	getRefreshEnableStatusAfterParamChange(strInputName)
	{
		return strInputName == 'use';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		let fStartScale;
		let fEndScale;
		if(inputValues['use'] === 'percent')
		{
			fStartScale = inputValues[`start_perc`]/100;
			fEndScale = inputValues[`end_perc`]/100;
		}
		else
		{
			fStartScale = inputValues[`start_dist`];
			fEndScale = inputValues[`end_dist`];
		}

		GeoUtils.taper(pGeoList, inputValues['direction'], fStartScale, fEndScale, inputValues['use'] === 'percent');
		return pGeoList;
	}
}